import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import EstateAgentsPage from "./pages/EstateAgentsPage";
import CommercialPage from "./pages/CommercialPage";
import NewsletterPage from "./pages/NewsletterPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import NotFoundPage from "./pages/NotFoundPage";
import CookieConsent from "./components/CookieConsent";

/**
 * The full route tree plus shared chrome (CookieConsent), router-agnostic.
 * Exported so the prerender pipeline can mount it under a MemoryRouter while
 * the live app mounts it under a BrowserRouter (see App below). Keeping the
 * routing primitive out of here is what lets both render paths share one tree.
 */
export function AppRoutes() {
  return (
    <div className="min-h-screen bg-background">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/estate-agents" element={<EstateAgentsPage />} />
        <Route path="/commercial" element={<CommercialPage />} />
        <Route path="/newsletter" element={<NewsletterPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App; 